// Chemins relatifs à la base `/api/v1` du client HTTP.
const base = (caseId: string) => `/compliance/kyb/legal-entity-cases/${caseId}/evidence-pack`;

const kybEvidencePackEndpoints = {
  snapshots: (caseId: string) => `${base(caseId)}/snapshots`,
  exports: (caseId: string) => `${base(caseId)}/exports`,
  exportPack: (caseId: string, format: string) => `${base(caseId)}/export?format=${format}`,
};

export default kybEvidencePackEndpoints;
